import { Validator } from "./ValidateAny";
import { Definition } from "../withForm";

export type Message = string | ((name: string) => string);

export function validateFromRoot<T>(key: string, self: Validator<T>) {
    return (data: any) => {
        const value = data[key];

        return self(value, data);
    }
}
export function validateAll<T>(target: T, definition: Definition<T>) {
    const result: string[] = [];

    for (const key of Object.keys(target)) {
        const item = definition[key].validateFromRoot(target);
        if (item)
            result.push(item.message);
    }
    return result;
}
export function getMessage(name: string, custom: Message, defaultMessage: string): string {
    if (typeof (custom) === 'string')
        return custom;
    else if (typeof (custom) === 'function')
        return custom(name);

    return defaultMessage;
}